import { render, staticRenderFns } from "./PeriodTabs.vue?vue&type=template&id=50ddb182&scoped=true&"
import script from "./PeriodTabs.vue?vue&type=script&lang=ts&"
export * from "./PeriodTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodTabs.vue?vue&type=style&index=0&id=50ddb182&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ddb182",
  null
  
)

export default component.exports